import { defineField, defineType } from "sanity";

export const programFileAttachmentType = defineType({
  type: "object",
  name: "programFileAttachment",
  title: "Program File Attachment",
  fields: [
    defineField({
      name: "name",
      type: "string",
      title: "Name",
      validation: (Rule) => Rule.required()
    }),
    defineField({
      name: "description",
      type: "string"
    }),
    defineField({
      name: "file",
      type: "file",
      title: "File",
      validation: (Rule) => Rule.required()
    })
  ]
});
